import { render } from "./UseCases.vue?vue&type=template&id=5d370f6a"
import script from "./UseCases.vue?vue&type=script&lang=js"
export * from "./UseCases.vue?vue&type=script&lang=js"

import "./UseCases.vue?vue&type=style&index=0&id=5d370f6a&lang=scss"

import exportComponent from "/builds/smartcom-gitlab-cis/maap/Application/Frontends/ProSpace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__